import React, {FC} from "react"
import GenericModal from "@irati/ui/src/GenericModal"
import {CompanyNewsTile, CompanyNewsTileType} from "@irati/types"
import {FormattedMessage} from "@irati/utils/lang"
import Spacing from "@irati/ui/src/Spacing"
import Flex from "@irati/ui/src/Flex"
import {ButtonLink} from "@irati/ui/src/Link"
import History from "@irati/utils/history"
import tracking from "@irati-tracking/homepage/cultureHub"
import {useCustomerFile} from "@irati/customer-files/hooks/customerFile"
import Image from "./Content/Image"
import Video from "./Content/Video"
import Template from "./Content/Template"

interface Props {
  tile?: CompanyNewsTile
  tilesCount?: number
}

const TileDetailsModal: FC<Props> = ({tile, tilesCount}) => {
  const {data} = useCustomerFile({uuid: tile?.config?.fileId}, {skip: !tile?.config?.fileId})
  const handleOnHide = () => {
    History.push({pathname: "/culture-hub"})
  }
  return (
    <GenericModal hideActions show={!!tile} onHide={handleOnHide}>
      <Spacing marginTop={3}>
        {tile?.config?.type === CompanyNewsTileType.Image && <Image companyNewsTile={tile} />}
        {tile?.config?.type === CompanyNewsTileType.Video && <Video companyNewsTile={tile} />}
        {tile?.config?.type === CompanyNewsTileType.Template && <Template companyNewsTile={tile} />}
        {tile?.config?.type === CompanyNewsTileType.File &&
          (tile.config.imageUrl ? <Image companyNewsTile={tile} /> : <Template companyNewsTile={tile} />)}

        {(tile?.config?.type === CompanyNewsTileType.Image || tile?.config?.type === CompanyNewsTileType.Template) &&
          !!tile?.config?.url && (
            <Flex justifyContent="flex-end">
              <ButtonLink
                primary
                href={tile?.config?.url}
                target="_blank"
                onClick={() => {
                  tracking.clickCultureHubCta("culturehub", "view")
                  tracking.cultureHubTileClick(tile?.config?.url, tilesCount, "deeplink")
                }}>
                <FormattedMessage id="platform.cta.view" />
              </ButtonLink>
            </Flex>
          )}

        {tile?.config?.type === CompanyNewsTileType.Video && !!tile?.config?.videoUrl && (
          <Flex justifyContent="flex-end">
            <ButtonLink
              primary
              href={tile?.config?.videoUrl}
              target="_blank"
              onClick={() => {
                tracking.clickCultureHubCta("culturehub", "view")
                tracking.cultureHubTileClick(tile?.config?.videoUrl, tilesCount, "deeplink")
              }}>
              <FormattedMessage id="platform.cta.view" />
            </ButtonLink>
          </Flex>
        )}

        {tile?.config?.type === CompanyNewsTileType.File && data?.downloadUrl && (
          <Flex justifyContent="flex-end">
            <ButtonLink
              primary
              onClick={() => {
                const viewerUrl = `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(data?.downloadUrl)}&disableDownload=true&toolbar=0`
                window.open(viewerUrl, "_blank")
                tracking.clickCultureHubCta("culturehub", "view")
                tracking.cultureHubTileClick(viewerUrl, tilesCount, "deeplink")
              }}>
              <FormattedMessage id="platform.cta.view" />
            </ButtonLink>
          </Flex>
        )}
      </Spacing>
    </GenericModal>
  )
}

export default TileDetailsModal
